import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_girl-activity-hub/artifacts/ohgdr8g2_Pink%20Black%20Simple%20Minimalist%20Aesthetic%20Ribbon%20Fashion%20Logo_20260702_100640_0000.png";

export default function Footer() {
  return (
    <footer
      className="border-t border-[#E8D7D0] bg-[#F9F6F0] py-16"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <img
            src={LOGO_URL}
            alt="Me Amor"
            className="h-16 w-auto object-contain -ml-1"
          />
          <p className="mt-4 text-sm text-[#7D6B6D] max-w-sm">
            Seasonal gift boxes and hair rituals for girls aged 4 to 15. A
            small studio built with big love.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.28em] uppercase text-[#7D6B6D]">
            Shop
          </div>
          <ul className="mt-4 space-y-2 text-sm text-[#36292A]">
            <li>
              <Link to="/#boxes" className="hover:text-[#C48B9F]">
                Seasonal Subscription Box
              </Link>
            </li>
            <li>
              <Link to="/#boxes" className="hover:text-[#C48B9F]">
                Activity Kit
              </Link>
            </li>
            <li>
              <Link to="/#boxes" className="hover:text-[#C48B9F]">
                Birthday Kit
              </Link>
            </li>
            <li>
              <Link to="/#boxes" className="hover:text-[#C48B9F]">
                Butterfly Collection
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.28em] uppercase text-[#7D6B6D]">
            Policies
          </div>
          <ul className="mt-4 space-y-2 text-sm text-[#36292A]">
            <li>
              <Link
                to="/terms"
                className="hover:text-[#C48B9F]"
                data-testid="footer-terms"
              >
                Terms of Service
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                className="hover:text-[#C48B9F]"
                data-testid="footer-privacy"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/refunds"
                className="hover:text-[#C48B9F]"
                data-testid="footer-refunds"
              >
                Refunds &amp; Cancellations
              </Link>
            </li>
            <li>
              <Link
                to="/shipping"
                className="hover:text-[#C48B9F]"
                data-testid="footer-shipping"
              >
                Shipping &amp; Delivery
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="text-xs tracking-[0.28em] uppercase text-[#7D6B6D]">
            Contact
          </div>
          <ul className="mt-4 space-y-2 text-sm text-[#36292A]">
            <li>
              <a
                href="mailto:empower.meamor@gmail.com"
                className="hover:text-[#C48B9F]"
              >
                empower.meamor@gmail.com
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/LovebyMeAmor"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:text-[#C48B9F]"
                data-testid="footer-facebook"
                aria-label="Me Amor on Facebook"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden
                >
                  <path d="M13.5 9H16V6h-2.5c-1.93 0-3.5 1.57-3.5 3.5V11H8v3h2v6h3v-6h2.5l.5-3H13V9.75c0-.41.34-.75.75-.75z" />
                </svg>
                Love by Me Amor
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 sm:px-10 mt-12 pt-6 border-t border-[#E8D7D0] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs tracking-[0.2em] uppercase text-[#7D6B6D]">
        <div>© {new Date().getFullYear()} Me Amor. Made with love.</div>
        <div data-testid="footer-nzbn">NZBN 9429049321432</div>
        <div>Confidence Starts Here</div>
      </div>
    </footer>
  );
}
